import React from 'react';

import {
  Form,
  FormItem,
  SubmitButton,
  Button,
  Input,
} from '../../../../components';
import { validateName } from '../../../knowledge-management/Knowledge/utils/validator';
import { SHORT_LINK_BASE } from '../../hooks/useShortLink';

export type ShortLinkFormProps = {
  short_link_identifier: string;
};

type ShortLinkProps = {
  formKey: string;
  form: ShortLinkFormProps;
  onCancel: () => void;
  onChange: (data: ShortLinkFormProps) => void;
  onSave: () => void;
  isDisabled?: boolean;
};

const ShortLinkForm: React.FC<ShortLinkProps> = ({
  onCancel,
  onChange,
  formKey,
  form,
  isDisabled,
  onSave,
}) => {
  const handleFormChange = (newForm: ShortLinkFormProps) => {
    const updatedForm = {
      ...newForm,
      short_link: newForm.short_link_identifier,
    };
    onChange(updatedForm);
  };

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <Form onChange={handleFormChange} initialValue={form} key={formKey}>
        <FormItem<ShortLinkFormProps>
          required
          name="short_link_identifier"
          label="Short link identifier"
          inline={false}
          labelClassName="text-medium text-secondary font-normal"
          validate={validateName}
        >
          <Input placeholder="Enter Name" />
        </FormItem>

        <div className="flex flex-col gap-y-sm">
          <label className="text-medium text-secondary">Short web-link</label>
          <div className="bg-gray-50 p-3 text-mainText rounded-xl border border-border">
            <span className="text-small text-secondary">{SHORT_LINK_BASE}</span>
            <span className="text-small text-mainText">
              {form.short_link_identifier}
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-y-md justify-center items-center">
          <SubmitButton
            size="medium"
            disabled={isDisabled}
            className="w-full"
            label="Create short link"
            onClick={onSave}
            loading={isDisabled}
          />
          <Button
            size="medium"
            type="contrast"
            label="Cancel"
            className="w-full text-main"
            onClick={onCancel}
          />
        </div>
      </Form>
    </div>
  );
};

export default ShortLinkForm;
